import { NavLink, Outlet } from "react-router";

const TABS = [
  { to: "/legal/terms", label: "Terms of Service" },
  { to: "/legal/privacy", label: "Privacy Policy" },
];

export default function LegalLayout() {
  return (
    <section className="relative px-6 pt-32 pb-24 sm:px-8 sm:pt-40">
      {/* Soft glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-0 h-80 w-200 -translate-x-1/2 rounded-full bg-main-500/8 blur-[160px]"
      />

      <div className="relative mx-auto max-w-3xl">
        <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-main-300">
          Legal
        </p>

        {/* Tabs */}
        <nav
          aria-label="Legal sections"
          className="mt-6 inline-flex rounded-full bg-card-2 p-1 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.07)]"
        >
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                `inline-flex h-10 items-center rounded-full px-5 text-sm font-medium transition ${
                  isActive
                    ? "bg-main-500 text-white shadow-[inset_0_1px_0_0_rgba(255,255,255,0.18)]"
                    : "text-text-soft hover:text-text"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>

        <article className="mt-12">
          <Outlet />
        </article>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────────────────
   Shared building blocks for legal content.
   ──────────────────────────────────────────────────────── */

export function LegalHeading({ title, updated }) {
  return (
    <header className="mb-12 border-b border-white/8 pb-8">
      <h1 className="text-4xl font-bold tracking-[-0.03em] text-text sm:text-5xl">
        {title}
      </h1>
      <p className="mt-3 text-sm text-text-muted">Last updated: {updated}</p>
    </header>
  );
}

export function Section({ title, children }) {
  return (
    <section className="mt-12 first:mt-0">
      <h2 className="text-xl font-bold tracking-[-0.02em] text-text sm:text-2xl">
        {title}
      </h2>
      <div className="mt-4 space-y-4 text-sm leading-7 text-text-soft sm:text-base">
        {children}
      </div>
    </section>
  );
}

export function SubSection({ title, children }) {
  return (
    <div className="mt-6">
      <h3 className="text-base font-semibold text-text sm:text-lg">{title}</h3>
      <div className="mt-2 space-y-3">{children}</div>
    </div>
  );
}

export function List({ children }) {
  return (
    <ul className="ml-5 list-disc space-y-2 text-text-soft marker:text-main-300">
      {children}
    </ul>
  );
}
